import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://villakosh.in';
const DEFAULT_OG_IMAGE = `${SITE_URL}/VillaKosh.png`;

const destinationMeta = {
  'lonavala': {
    title: 'Luxury Villas in Lonavala | Private Pool Villas & Bungalows | VillaKosh',
    description: 'Book premium villas in Lonavala with private pools, amazing valley views, and modern amenities. Perfect for family vacations, corporate retreats, and weekend getaways. Best prices guaranteed.',
    keywords: 'villas in lonavala, lonavala villas with pool, luxury villas lonavala, lonavala bungalows, villa on rent in lonavala',
    faqs: [
      { q: 'What is the best time to visit Lonavala?', a: 'Lonavala is great year-round. Monsoon (June–September) offers lush greenery and waterfalls. Winter (November–February) is ideal for pleasant weather. Summer weekends are popular for pool villas.' },
      { q: 'How far is Lonavala from Mumbai?', a: 'Lonavala is approximately 83 km from Mumbai, about 1.5–2 hours by car via the Mumbai-Pune Expressway.' },
      { q: 'Do villas in Lonavala have private pools?', a: 'Yes, most villas listed on VillaKosh in Lonavala come with private swimming pools, along with amenities like BBQ, gardens, and indoor games.' },
      { q: 'What is the average cost of renting a villa in Lonavala?', a: 'Villa prices in Lonavala range from ₹5,000 to ₹25,000 per night depending on size, amenities, and season. Weekend rates may be higher.' },
    ],
  },
  'karjat': {
    title: 'Villas in Karjat | Farmhouses & Pool Villas Near Mumbai | VillaKosh',
    description: 'Explore scenic villas and farmhouses in Karjat. Ideal for weekend breaks from Mumbai & Pune. Featuring private pools, garden spaces, and mountain views. Best deals on villa stays.',
    keywords: 'villas in karjat, karjat farmhouse, pool villa karjat, weekend getaway near mumbai, karjat villas',
    faqs: [
      { q: 'How far is Karjat from Mumbai?', a: 'Karjat is about 62 km from Mumbai, roughly 1.5 hours by road. It is well-connected by both road and local trains.' },
      { q: 'What activities can you do in Karjat?', a: 'Popular activities include trekking, river rafting, waterfall visits during monsoon, and relaxing in private pool villas surrounded by nature.' },
      { q: 'Are Karjat villas suitable for large groups?', a: 'Yes, many farmhouses and villas in Karjat accommodate 10–30 guests with multiple bedrooms, open lawns, and party-friendly spaces.' },
    ],
  },
  'alibag': {
    title: 'Beach Villas in Alibaug | Luxury Beach Houses & Pools | VillaKosh',
    description: 'Discover beachfront villas in Alibaug with private pools and sea views. Perfect for beach vacations and family gatherings. Easy access from Mumbai via ferry. Book at best prices.',
    keywords: 'alibaug villas, beach houses alibaug, villa with pool alibaug, weekend homes alibaug, beachfront villas',
    faqs: [
      { q: 'How do I reach Alibag from Mumbai?', a: 'You can reach Alibag by road (about 95 km, 2–3 hours) or by ferry from Gateway of India to Mandwa jetty (about 1 hour), followed by a short drive.' },
      { q: 'Are there beach-facing villas in Alibag?', a: 'Yes, VillaKosh lists several villas in Alibag with beach views, beachfront access, and private pools close to popular beaches like Kashid and Nagaon.' },
      { q: 'What is the best season to visit Alibag?', a: 'October to March offers the best weather with cool sea breezes. Monsoon (June–September) brings lush greenery but some beach activities may be limited.' },
    ],
  },
  'igatpuri': {
    title: 'Hill Station Villas in Igatpuri | Mountain View Stays | VillaKosh',
    description: 'Book peaceful mountain villas in Igatpuri with stunning valley views. Escape the city heat with cool climate and serene surroundings. Perfect for family holidays and group stays.',
    keywords: 'igatpuri villas, mountain villas igatpuri, holiday homes igatpuri, villa stay in igatpuri, weekend getaway',
    faqs: [
      { q: 'How far is Igatpuri from Mumbai?', a: 'Igatpuri is approximately 120 km from Mumbai, about 2–2.5 hours by road via the Mumbai-Nashik Highway.' },
      { q: 'What makes Igatpuri a good vacation destination?', a: 'Igatpuri offers cool temperatures year-round, beautiful Sahyadri mountain views, waterfalls during monsoon, and peaceful surroundings ideal for relaxation and meditation.' },
      { q: 'Are there pool villas available in Igatpuri?', a: 'Yes, several villas in Igatpuri on VillaKosh feature private pools along with mountain views, gardens, and BBQ areas.' },
    ],
  },
  'panchgani': {
    title: 'Luxury Villas in Panchgani | Hill Station Retreats | VillaKosh',
    description: 'Experience premium villa stays in Panchgani with panoramic valley views. Ideal for family vacations and group outings. Enjoy cool climate and scenic beauty throughout the year.',
    keywords: 'panchgani villas, luxury stays panchgani, villa with valley view, holiday homes panchgani',
    faqs: [
      { q: 'How far is Panchgani from Pune?', a: 'Panchgani is about 100 km from Pune, approximately 2.5 hours by road. It is also about 250 km from Mumbai (5 hours).' },
      { q: 'What are the top attractions near Panchgani?', a: 'Popular spots include Table Land (Asia\'s second longest mountain plateau), Sydney Point, Parsi Point, Mapro Garden, and numerous trekking trails.' },
      { q: 'Is Panchgani good for a family vacation?', a: 'Yes, Panchgani\'s pleasant climate, scenic viewpoints, strawberry farms, and peaceful villas make it perfect for family getaways year-round.' },
    ],
  },
  'neral': {
    title: 'Villas in Neral | Private Pool Villas Near Matheran | VillaKosh',
    description: 'Book scenic villas in Neral near Matheran hill station. Private pools, lush greenery, and peaceful surroundings. Perfect weekend getaway from Mumbai and Pune.',
    keywords: 'neral villas, villas near matheran, pool villa neral, weekend getaway neral, farmhouse neral',
    faqs: [
      { q: 'How far is Neral from Mumbai?', a: 'Neral is about 75 km from Mumbai, roughly 1.5 hours by road or train. It serves as the base for visiting Matheran hill station.' },
      { q: 'What is special about villas in Neral?', a: 'Neral offers affordable luxury villas surrounded by dense greenery, close to Matheran. Most villas feature private pools, spacious lawns, and a quiet escape from city life.' },
      { q: 'Can I visit Matheran from Neral?', a: 'Yes, Matheran is just 8 km from Neral. You can reach it by the famous Matheran toy train, by foot, or by car up to the entry gate.' },
    ],
  },
};

function buildFaqSchema(faqs) {
  if (!faqs || faqs.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}

function buildBreadcrumbSchema(destination) {
  const items = [
    { name: 'Home', url: SITE_URL },
  ];
  if (destination) {
    items.push({
      name: `Villas in ${destination.charAt(0).toUpperCase() + destination.slice(1)}`,
      url: `${SITE_URL}/villas-in-${destination.toLowerCase()}`,
    });
  }
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export default function SEOHead({ destination }) {
  const destinationSlug = destination?.toLowerCase();
  const meta = destinationMeta[destinationSlug] || {
    title: 'VillaKosh - Premium Villa Stays in Maharashtra',
    description: 'Discover and book luxurious villas across Maharashtra. Find the perfect villa for your vacation with private pools, amazing views, and modern amenities.',
    keywords: 'villa booking, luxury stays, vacation rentals, Maharashtra villas',
    faqs: [],
  };

  const canonicalUrl = destinationSlug
    ? `${SITE_URL}/villas-in-${destinationSlug}`
    : SITE_URL;

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: meta.title,
    description: meta.description,
    url: canonicalUrl,
    inLanguage: 'en-IN',
    publisher: {
      '@type': 'Organization',
      name: 'VillaKosh',
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: DEFAULT_OG_IMAGE,
      },
    },
  };

  const faqSchema = buildFaqSchema(meta.faqs);
  const breadcrumbSchema = buildBreadcrumbSchema(destinationSlug);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />
      <meta property="og:site_name" content="VillaKosh" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={DEFAULT_OG_IMAGE} />

      {/* Structured Data — WebPage */}
      <script type="application/ld+json">
        {JSON.stringify(webPageSchema)}
      </script>

      {/* Structured Data — BreadcrumbList */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>

      {/* Structured Data — FAQPage (if available) */}
      {faqSchema && (
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      )}
    </Helmet>
  );
}
